import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {Box, Button, Menu, MenuItem} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {CommunicationNode} from '../../interfaces/CommunicationNodeV2';
import {buildHistoryReportUrl} from '../../utils/historyReportUrl';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  item?: CommunicationNode;
  externalId?: number | string;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  onOpen?: (type: 'cn' | 'commtracNodeByCn') => void;
}

const CommunicationNodeItemHistoryButton = <
  T extends ComponentType = typeof Button,
>({
  // item,
  externalId,
  component,
  componentProps,
  children,
  onOpen,
}: Props<T>) => {
  const Component = component ?? Button;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const openInNewTab = (type: 'cn' | 'commtracNodeByCn') => {
    if (externalId === undefined || externalId === null) {
      return;
    }
    const url = buildHistoryReportUrl(type, externalId);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Component
        {...componentProps}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {children}
      </Component>

      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onBackdropClick={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            onOpen?.('cn');
            setAnchorEl(null);
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            gap={1}
          >
            <span>View History</span>
            {externalId !== undefined && externalId !== null ? (
              <OpenInNewIcon
                fontSize="small"
                onClick={(event) => {
                  event.stopPropagation();
                  openInNewTab('cn');
                  setAnchorEl(null);
                }}
                aria-label="Open in new tab"
                sx={{cursor: 'pointer', color: 'text.secondary'}}
              />
            ) : null}
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpen?.('commtracNodeByCn');
            setAnchorEl(null);
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            gap={1}
          >
            <span>View Employee/Asset</span>
            {externalId !== undefined && externalId !== null ? (
              <OpenInNewIcon
                fontSize="small"
                onClick={(event) => {
                  event.stopPropagation();
                  openInNewTab('commtracNodeByCn');
                  setAnchorEl(null);
                }}
                aria-label="Open in new tab"
                sx={{cursor: 'pointer', color: 'text.secondary'}}
              />
            ) : null}
          </Box>
        </MenuItem>
      </Menu>
    </>
  );
};

export default CommunicationNodeItemHistoryButton;
